import React, { PropTypes } from 'react';
import { Link } from 'react-router';
import Money from 'common/components/money';
import ProjectLink from 'common/containers/project_link';
import { ADMIN_ROOT } from 'common/variables';

/**
 * Payment awards.
 *
 * @author Nathan Ozelim <nathan@startupfoundry.com>
 */
const PaymentAwards = ({ item, type, className, atAdmin }) => {
  return (
    <tr className={"awards " + className}>
      <td colSpan={5}>
        <h4>Awards</h4>

        <ul>
          {item.awards.map((award, i) => {
            return (<li key={i}>
              <Money value={award.amount} />
              { atAdmin?
              <Link target="_blank" to={`${ADMIN_ROOT}/project/${award.project.id}/`}>
                { award.project.title }
              </Link> :
              <ProjectLink target="_blank" project={award.project} /> }
            </li>)
          })}
        </ul>

        { item.external_comment &&
        <div className="notes">
          <h5>Notes:</h5>
          <p>{ item.external_comment }</p>
        </div>}

      </td>
  </tr>);
};

PaymentAwards.propTypes = {
  item: PropTypes.object,
  type: PropTypes.string,
  className: PropTypes.string,
  atAdmin: PropTypes.bool
};

export default PaymentAwards;



// WEBPACK FOOTER //
// ./account/components/payout/payment_awards.jsx